import React from "react";

import Table from "components/Table";
import { orderDeliveriesColumns } from "./columns";

interface IProps {
  isLoading: boolean;
  onRowClick: (any) => void;
  loadData: () => void;
  data: any[];
}

class OrderDeliveries extends React.PureComponent<IProps> {
  public componentDidMount() {
    this.props.loadData();
  }

  public render() {
    const { isLoading, onRowClick, data } = this.props;

    return (
      <Table
        columns={orderDeliveriesColumns}
        dataSource={data}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    );
  }
}

export default OrderDeliveries;
